import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import DebtReliefOfficeWrapper from "@components/layouts/debtReliefOfficeWrapper";
import { useDomainContext } from "@hooks/useDomainContext";

export default function TermsAndConditionsHome(): ReactElement {
    const { domain } = useDomainContext();
    return (
        <DebtReliefOfficeWrapper>
            <TermsAndConditions
                category={domain?.categories[0]?.name}
                domain={domain.niceName}
            />
        </DebtReliefOfficeWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
